import { useSelector } from "react-redux"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"
import { getHasPartnerInfo } from "derivedSelectors"
import Journeys from "utils/Journeys"
import Interests from "utils/Interests"
import L10n from "lib/carrot-l10n"
import { JourneyPaths } from "./JourneyPaths"
import { BenefitConfiguration } from "types/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

function addPrePregnancyOptions(hasPartner, result) {
  result.push({
    id: "OUR_TRYING_TO_GET_PREGNANT",
    labelKey: hasPartner ? l`My partner and I are trying to get pregnant` : l`I’m trying to get pregnant`,
    journey: Journeys.TAKING_ACTION,
    interest: Interests.TRYING_TO_GET_PREGNANT,
    next: "/fle/journey/trying-to-get-pregnant",
    pronouns: {}
  })
}

function addPregnancyOptions(hasPartner, result) {
  result.push({
    id: "AM_OR_ARE_PREGNANT",
    labelKey: hasPartner ? l`My partner and I are pregnant` : l`I'm pregnant`,
    journey: Journeys.PREGNANCY,
    interest: Interests.PREGNANT,
    next: JourneyPaths.STARTED_SEEING_DOCTOR,
    pronouns: {}
  })
}

type JourneyChoice = {
  id: string
  labelKey: string
  journey: Journeys
  interest?: Interests
  next: string
  filter?: (config: BenefitConfiguration) => boolean
  pronouns: {
    singular: string
    plural: string
  }
}

const GetJourneyChoicesAndNextSteps = (): JourneyChoice[] => {
  const {
    featureConfig: { isCarrotPregnancyEnabled: hasPregnancy }
  } = useSelector(getBenefitConfiguration)
  const hasPartner = useSelector(getHasPartnerInfo)

  const result: JourneyChoice[] = [
    {
      id: Journeys.LEARN_MORE,
      labelKey: "fle2.journeychoices.learnmore",
      journey: Journeys.LEARN_MORE,
      next: "/fle/journey/learn-more",
      pronouns: {
        singular: "I",
        plural: "we"
      }
    },
    {
      id: Journeys.READY_FOR_NEXT_STEP,
      labelKey: "fle2.journeychoices.nextstep",
      journey: Journeys.READY_FOR_NEXT_STEP,
      next: "/fle/journey/next-step",
      pronouns: {
        singular: "I'm",
        plural: "We're"
      }
    },
    {
      id: "RECEIVING_FERTILITY_CARE",
      labelKey: "fle2.journeychoices.receivingcare",
      journey: Journeys.TAKING_ACTION,
      next: "/fle/journey/receiving-care",
      pronouns: {
        singular: "I'm",
        plural: "We're"
      }
    },
    {
      id: "PURSUING_ADOPTING",
      labelKey: "fle2.journeychoices.adopting",
      journey: Journeys.TAKING_ACTION,
      interest: Interests.ADOPTING,
      filter: (config) => config.featureConfig.isAdoptionEnabled,
      next: "/fle/done",
      pronouns: {
        singular: "I'm",
        plural: "We're"
      }
    },
    {
      id: "PURSUING_GESTATIONAL_CARRIER",
      labelKey: "fle2.journeychoices.gestationalcarrier",
      journey: Journeys.TAKING_ACTION,
      interest: Interests.GESTATIONAL_CARRIER,
      filter: (config) => config.featureConfig.isGcEnabled,
      next: "/fle/done",
      pronouns: {
        singular: "I'm",
        plural: "We're"
      }
    }
  ]

  addPrePregnancyOptions(hasPartner, result)

  if (hasPregnancy) {
    addPregnancyOptions(hasPartner, result)
  }

  return result
}

export { GetJourneyChoicesAndNextSteps }
